/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicaidCaseWorkspace } from './MedicaidCaseWorkspace';
import {
    MedicaidCaseWorkspaceFromJSON,
    MedicaidCaseWorkspaceFromJSONTyped,
    MedicaidCaseWorkspaceToJSON,
    MedicaidCaseWorkspaceToJSONTyped,
} from './MedicaidCaseWorkspace';

/**
 * 
 * @export
 * @interface MedicaidCaseWorkspaceResponse
 */
export interface MedicaidCaseWorkspaceResponse {
    /**
     * 
     */
    data: MedicaidCaseWorkspace;
}

/**
 * Check if a given object implements the MedicaidCaseWorkspaceResponse interface.
 */
export function instanceOfMedicaidCaseWorkspaceResponse(value: object): value is MedicaidCaseWorkspaceResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function MedicaidCaseWorkspaceResponseFromJSON(json: any): MedicaidCaseWorkspaceResponse {
    return MedicaidCaseWorkspaceResponseFromJSONTyped(json, false);
}

export function MedicaidCaseWorkspaceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicaidCaseWorkspaceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': MedicaidCaseWorkspaceFromJSON(json['data']),
    };
}

export function MedicaidCaseWorkspaceResponseToJSON(json: any): MedicaidCaseWorkspaceResponse {
    return MedicaidCaseWorkspaceResponseToJSONTyped(json, false);
}

export function MedicaidCaseWorkspaceResponseToJSONTyped(value?: MedicaidCaseWorkspaceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MedicaidCaseWorkspaceToJSON(value['data']),
    };
}

